
/**
 *重命名组件
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import NewFolderModel from "./NewFolderModel";
import BaseComponent from "../../../base/BaseComponent";
import {message} from './Mess'
import MyIconSvg from "./svg/Svg";


export default class NewFolder  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return(
                <div>{
                    this.props.text?<span  style={{cursor:"pointer"}} onClick={() => this.rename()}>重命名</span>:<Button style={{marginRight: 5,display: 'flex', alignItems:'center'}}  onClick={() => this.rename()}> <MyIconSvg type={"ReName"} style={{marginTop:'2px'}} colors={[newSecondSelectColor]}/>
                        重命名</Button>
                }
                <NewFolderModel  onRef={(newFolder)=>this.setNewFolder = newFolder}  callBack={(currentId,current,checkArray)=>{
                    // this.props.callBack&&this.props.callBack(currentId,current,checkArray,true,false)
                    this.props.callBack&&this.props.callBack()
                }}></NewFolderModel>
            </div>
        )
    }
    //重命名
    rename() {
        this.props.hideCallBack&&this.props.hideCallBack();
        if (this.props.checkArray.length) {
            if(this.props.checkArray.length>1){
                message.error('重命名只能选择一个文件夹或者文件！')
            }else{
                this.setNewFolder.show(true,'重命名','',this.props.checkArray,this.props.IsDefault,this.props.IsTile)
            }

        } else {
            message.error('至少选择一个文件夹或者文件！')
        }
    }


}
